<template>
  <path
    d="M12 2.00024C6.48 2.00024 2 6.48024 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48024 17.52 2.00024 12 2.00024ZM12 20.0002C7.58 20.0002 4 16.4202 4 12.0002C4 10.1502 4.63 8.45024 5.69 7.10024L16.9 18.3102C15.55 19.3702 13.85 20.0002 12 20.0002ZM18.31 16.9002L7.1 5.69024C8.45 4.63024 10.15 4.00024 12 4.00024C16.42 4.00024 20 7.58024 20 12.0002C20 13.8502 19.37 15.5502 18.31 16.9002Z"
  />
</template>
